<template>
  <el-dropdown @command="handleCommand" class="dropdown">
    <span class="el-dropdown-link">
      {{ getCommandText }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in this.languageList" :key="item.key" :command="item.key">
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { LOCALE_STORE_KEY } from '../constant'
import { setLocal, getLocal } from '@meta-vue/util'
export default {
  props: ['localesResult'],
  computed: {
    getCommandText() {
      return this.languageList.find(item => item.key === (this.languageCommand || ''))?.label || ''
    }
  },
  data() {
    return {
      languageList: [],
      languageCommand: '', //语言
      command: '' //国家
    }
  },
  created() {},
  methods: {
    handleCommand(languageCommand) {
      this.languageCommand = languageCommand
      const locales = getLocal(LOCALE_STORE_KEY)
      setLocal(
        LOCALE_STORE_KEY,
        { country: locales.country, lang: this.languageCommand, timeZone: locales.timeZone },
        { expire: 1000 * 60 * 60 * 24 * 365 }
      )
      window.location.reload()
    }
  },
  watch: {
    localesResult(value) {
      const locales = getLocal(LOCALE_STORE_KEY)
      this.command = locales.country
      this.languageCommand = locales.lang
      this.languageList = this.localesResult.find(item => item.country.key === this.command).languages
    }
  }
}
</script>

<style lang="stylus" scoped>
.dropdown {
  margin-right: 16px;
  cursor: pointer;
}
</style>
